import React from 'react';
import PropTypes from 'prop-types';
import DataGridBaseLink from './DataGridBaseLink';

const DataGridBaseNoLink = ({ children, ...props }) => {
  return (
    <DataGridBaseLink {...props} noLink>
      {children}
    </DataGridBaseLink>
  );
};

DataGridBaseNoLink.propTypes = {
  children: PropTypes.any,
};

export default React.memo(DataGridBaseNoLink);
